import DashboardPanouPrincipal from "../panou-principal";

export default function DashboardSesizariSolutionate(props) {
  return <DashboardPanouPrincipal filterStatus="resolved" title="Sesizări soluționate" {...props} />;
}